<div class="palette-background-color-white">
    <app-header></app-header>
    <ng-content></ng-content>
    <br>
    <app-footer></app-footer>
</div>